import { Navigate } from "react-router-dom";
import LoginPage from "../pages/Login/LoginPage";
import { routes } from "../helpers/constants";
import TakeDetails from "../pages/TakeDetails";
import Reports from "../pages/Reports";

export const authRoutes = [
  { path: routes.homepage, element: <Navigate to={routes.login} /> },
  { path: routes.login, element: <LoginPage /> },
];

export const mainRoutes = [
  {
    path: routes.homepage,
    element: <Navigate to={routes.takeDetails} />,
  },
  { path: routes.takeDetails, element: <TakeDetails /> },
  { path: routes.reports, element: <Reports /> },
];

export const invalidRoutes = [
  { path: "*", element: <LoginPage /> },
  { path: routes.login, element: <LoginPage /> },
];
